import React, { useState } from "react";
import { FaPlus, FaSearch, FaCommentAlt, FaList } from "react-icons/fa";
import { IconType } from "react-icons";

export enum TabType {
  ADD_ENTRY = "Add",
  CHAT = "Chat",
  //SEARCH = "Search",
  //BROWSE = "Browse",
}

const iconMap: Record<TabType, IconType> = {
  [TabType.ADD_ENTRY]: FaPlus,
  [TabType.CHAT]: FaCommentAlt,
  //[TabType.SEARCH]: FaSearch,
  //[TabType.BROWSE]: FaList,
};

const descriptionMap: Record<TabType, string> = {
  [TabType.ADD_ENTRY]: "Add a new entry to the workspace",
  [TabType.CHAT]: "Chat with your data",
  //[TabType.SEARCH]: "Search for entries",
  //[TabType.BROWSE]: "Browse existing entries",
};

interface DrawerTabBarProps {
  activeTab: TabType;
  onSetActiveTab: (activeTab: TabType) => void;
}

const DrawerTabBar: React.FC<DrawerTabBarProps> = (
  props: DrawerTabBarProps,
) => {
  const handleOnClickTab = (tab: TabType) => {
    props.onSetActiveTab(tab);
  };

  return (
    <div className="flex border-2 border-palette-3 bg-palette-3">
      {Object.values(TabType).map((tab: TabType) => {
        const isActive = props.activeTab === tab;
        let base = "cursor-pointer px-6 py-6 transition-all";
        base += " flex flex-col justify-center items-center";
        const selected = "text-palette-1 bg-palette-5";
        const notSelected = "text-palette-1 bg-palette-3";
        const className = `${base} ${isActive ? selected : notSelected}`;
        const IconComponent: IconType = iconMap[tab];
        return (
          <div
            key={`drawerTabBar:${tab}`}
            title={descriptionMap[tab]}
            onClick={() => handleOnClickTab(tab)}
            className={className}
          >
            <IconComponent />
          </div>
        );
      })}
    </div>
  );
};

export default DrawerTabBar;
